module.exports = __webpack_public_path__ + "img/20.50ad2adb.jpg";